import { render } from "./pageHeader.vue?vue&type=template&id=0b435652"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"

import "./pageHeader.vue?vue&type=style&index=0&id=0b435652&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__